import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "leftArrow", "rightArrow"]

  connect() {
    this.handleWheel = this.handleWheel.bind(this)
    // コンテナではなくdocumentにイベントリスナーを設定
    document.addEventListener('wheel', this.handleWheel, { passive: false })

    // スクロール位置変更時に矢印表示を更新
    if (this.hasContainerTarget) {
      this.containerTarget.addEventListener('scroll', this.updateArrows.bind(this))
    }

    // コンテナの表示状態を監視
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const ratio = entry.intersectionRatio
            if (ratio > 0.3) { // 30%以上表示されたら
              this.enableHorizontalMode()
              // 水平モード有効時に矢印状態を更新
              this.updateArrows()
            } else {
              this.disableHorizontalMode()
            }
          } else {
            this.disableHorizontalMode()
          }
        })
      },
      {
        threshold: [0, 0.3, 1.0],  // 0%, 30%, 100%の表示状態を監視
        rootMargin: '-30% 0px'     // 画面中央付近でトリガー
      }
    )

    this.observer.observe(this.containerTarget)
  }

  disconnect() {
    document.removeEventListener('wheel', this.handleWheel)
    if (this.hasContainerTarget) {
      this.containerTarget.removeEventListener('scroll', this.updateArrows.bind(this))
    }
    this.observer.disconnect()
  }

  // 新規追加: 矢印の表示/非表示を制御するメソッド
  updateArrows() {
    if (!this.hasContainerTarget) return
    if (!this.hasLeftArrowTarget || !this.hasRightArrowTarget) return

    const container = this.containerTarget
    const atStart = container.scrollLeft <= 0
    const atEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 1

    // 左矢印の表示/非表示
    if (atStart) {
      this.leftArrowTarget.classList.add('hidden')
    } else {
      this.leftArrowTarget.classList.remove('hidden')
    }

    // 右矢印の表示/非表示
    if (atEnd) {
      this.rightArrowTarget.classList.add('hidden')
    } else {
      this.rightArrowTarget.classList.remove('hidden')
    }
  }

  handleWheel(event) {
    const container = this.containerTarget
    const containerRect = container.getBoundingClientRect()
    const viewportHeight = window.innerHeight
    const containerCenter = containerRect.top + containerRect.height / 2
    const viewportCenter = viewportHeight / 2

    // コンテナが画面中央付近にある場合のみ横スクロールを処理
    if (this.isHorizontalMode && Math.abs(containerCenter - viewportCenter) < viewportHeight * 0.3) {
      // スクロール終端のチェック
      const atStart = container.scrollLeft <= 0
      const atEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth

      if (atEnd && event.deltaY > 0) {
        // 終端で下方向へのスクロールの場合は、縦スクロールを許可
        return
      }

      if (atStart && event.deltaY < 0) {
        // 開始位置で上方向へのスクロールの場合は、縦スクロールを許可
        return
      }

      // 横スクロールモード中は常にデフォルトの縦スクロールを防ぐ
      event.preventDefault()
      container.scrollLeft += event.deltaY * 0.5

      // ホイールスクロール後に矢印状態を更新
      this.updateArrows()
    }
  }

  enableHorizontalMode() {
    if (this.hasHorizontalScroll()) {
      this.isHorizontalMode = true
      this.containerTarget.style.overflowX = 'auto'
    }
  }

  disableHorizontalMode() {
    this.isHorizontalMode = false
    this.containerTarget.style.overflowX = ''

    // 水平モード無効時は両方の矢印を非表示
    if (this.hasLeftArrowTarget) this.leftArrowTarget.classList.add('hidden')
    if (this.hasRightArrowTarget) this.rightArrowTarget.classList.add('hidden')
  }

  hasHorizontalScroll() {
    const container = this.containerTarget
    return container.scrollWidth > container.clientWidth
  }

  // 既存のイベントハンドラにスクロール後の矢印更新処理を追加
  scrollLeft() {
    this.updateArrows()
  }

  scrollRight() {
    this.updateArrows()
  }
}